import React from "react";
import { render } from "react-dom";
import { Provider } from 'react-redux'

import store from '../wave_solder_pallets/store'
import App from "../wave_solder_pallets/App";
import Cart from "../surface_mount_carriers/Cart";

document.addEventListener("DOMContentLoaded", () => {
  var appContainer = document.getElementById("quote-form");
  var cartContainer = document.getElementById("cart-form");
  if (appContainer != null) {
    render(
      <Provider store={store} >
        <App />
      </Provider>,
      appContainer
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store} >
        <Cart />
      </Provider>,
      cartContainer
    );
  }
});
